import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ContentsVideoModalComponent } from '../contentі-video-modal/contents-video-modal.component';

export enum ContentVideoType {
  ContentCoverage = 'ContentCoverage',
  LiabilityCoverage = 'LiabilityCoverage',
  AdditionalInterest = 'AdditionalInterest',
}

export interface ContentVideoConfig {
  type: ContentVideoType,
  message: string,
  src: string
}

export const CONTENT_VIDEO_CONFIG: Map<ContentVideoType, ContentVideoConfig> = new Map([
  [
    ContentVideoType.AdditionalInterest,
    {
      type: ContentVideoType.AdditionalInterest,
      message: 'What is Additional Interest?',
      src: 'https://player.vimeo.com/video/1069017459?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
    }
  ],
  [
    ContentVideoType.LiabilityCoverage,
    {
      type: ContentVideoType.LiabilityCoverage,
      message: 'What is Liability Coverage?',
      src: 'https://player.vimeo.com/video/1122974008?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
    }
  ],
  [
    ContentVideoType.ContentCoverage,
    {
      type: ContentVideoType.ContentCoverage,
      message: 'What is Contents Coverage?',
      src: 'https://player.vimeo.com/video/1123216166?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
    }
  ],

]);

@Component({
    selector: 'app-contents-video-link',
    templateUrl: './content-video-link.component.html',
    styleUrls: ['./content-video-link.component.scss'],
    standalone: false
})
export class ContentVideoLinkComponent {

  private _type!: ContentVideoType;
  public config!: ContentVideoConfig;

  public get type(): ContentVideoType {
    return this._type;
  }

  @Input() set type(value: ContentVideoType) {
    this._type = value;

    const config: ContentVideoConfig = CONTENT_VIDEO_CONFIG.get(this.type);

    if (config) {
      this.config = config;
    }
  }

  @Input() reducedPaddings: boolean

  constructor(public dialog: MatDialog) {
  }

  openModal(event: Event): void {
    event.preventDefault();

    const isMobile = this.isMobileDevice();

    if (this.config) {
      this.dialog.open(ContentsVideoModalComponent, {
        width: isMobile ? '95vw' : '800px',
        height: isMobile ? '50vh' : '540px',
        maxWidth: '1280px',
        maxHeight: '90vh',
        panelClass: 'contents-video-dialog',
        autoFocus: false,
        restoreFocus: true,
        data: {
          title: this.config?.message,
          videoUrl: this.config?.src
        }
      });
    }
  }

  private isMobileDevice(): boolean {
    // eslint-disable-next-line
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    const isMobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);

    const screenWidth = window.innerWidth || document.documentElement.clientWidth || screen.width;
    const isMobileScreen = screenWidth < 768;

    const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    return isMobileUA || (isMobileScreen && hasTouch);
  }
}
